import { Table } from "@tanstack/react-table"
import { XMarkIcon } from "@heroicons/react/24/outline"
import { DataTableViewOptions } from "./DataTableViewOptions"

interface DataTableToolbarProps<TData> {
  table: Table<TData>
  searchKey?: string
  searchPlaceholder?: string
  globalFilter: string
  setGlobalFilter: (value: string) => void
  showColumnVisibility?: boolean
  enableRowSelection?: boolean
}

export function DataTableToolbar<TData>({
  table,
  searchKey,
  searchPlaceholder,
  globalFilter,
  setGlobalFilter,
  showColumnVisibility = true,
  enableRowSelection = false,
}: DataTableToolbarProps<TData>) {
  const isFiltered = table.getState().columnFilters.length > 0 || globalFilter !== ""
  const selectedRowsCount = table.getFilteredSelectedRowModel().rows.length
  const totalRowsCount = table.getFilteredRowModel().rows.length

  return (
    <div className="flex items-center justify-between">
      <div className="flex flex-1 items-center space-x-2">
        {enableRowSelection && selectedRowsCount > 0 && (
          <div className="flex items-center space-x-2 text-sm text-muted-foreground">
            <span>{selectedRowsCount} of {totalRowsCount} row(s) selected</span>
            <button
              onClick={() => table.resetRowSelection()}
              className="text-xs text-primary hover:underline"
            >
              Clear selection
            </button>
          </div>
        )}
        {(!enableRowSelection || selectedRowsCount === 0) && (
          <>
            <input
              placeholder={
                searchPlaceholder ?? `Search${searchKey ? ` by ${searchKey}` : ""}...`
              }
              value={globalFilter ?? ""}
              onChange={(event) => setGlobalFilter(event.target.value)}
              className="h-9 w-[150px] lg:w-[250px] rounded-md border border-border bg-background px-3 py-1 text-sm placeholder:text-secondary focus:outline-none focus:ring-2 focus:ring-primary"
            />
            {isFiltered && (
              <button
                onClick={() => {
                  table.resetColumnFilters()
                  setGlobalFilter("")
                }}
                className="h-9 px-2 lg:px-3 inline-flex items-center justify-center rounded-md text-sm font-medium hover:bg-surface transition-colors"
              >
                Reset
                <XMarkIcon className="ml-2 h-4 w-4" />
              </button>
            )}
          </>
        )}
      </div>
      {showColumnVisibility && <DataTableViewOptions table={table} />}
    </div>
  )
}